import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return <Result status="404" title="404" subTitle="该地址不存在或尚未开放。" extra={<Link to="/"><Button type="primary">返回工作首页</Button></Link>} />;
}
